import { render } from "./MyListFolderListItem.vue?vue&type=template&id=968919dc&scoped=true&ts=true"
import script from "./MyListFolderListItem.vue?vue&type=script&lang=ts"
export * from "./MyListFolderListItem.vue?vue&type=script&lang=ts"

import "./MyListFolderListItem.vue?vue&type=style&index=0&id=968919dc&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-968919dc"]])

export default __exports__